import { ShigoDashboardContext } from '../../features/auth/dashboardDestination';
import { ShigoPermission } from '../../features/auth/permissions';
import { ShigoNavigationItem, type ShigoNavigationGroup } from './shigo-navigation.types';

export const shigoReportingNavigationGroup: ShigoNavigationGroup = {
  id: ShigoNavigationItem.Reporting,
  labelKey: 'nav.reporting',
  activePaths: ['/reporting', '/p/$publisherId/reporting'],
  access: [
    {
      contexts: [ShigoDashboardContext.Main, ShigoDashboardContext.SuperAdmin],
      permissions: [ShigoPermission.ReportingRead],
    },
    {
      contexts: [ShigoDashboardContext.Publisher],
      permissions: [
        ShigoPermission.PublisherDashboardRead,
        ShigoPermission.PublisherDashboardReportingRead,
      ],
    },
  ],
  entries: [
    {
      id: ShigoNavigationItem.ReportExplorer,
      labelKey: 'nav.reporting.reportExplorer',
      to: ({ dashboardContext }) =>
        dashboardContext === ShigoDashboardContext.Publisher
          ? '/p/$publisherId/reporting/report-explorer'
          : '/reporting/report-explorer',
      activePaths: ['/reporting/report-explorer', '/p/$publisherId/reporting/report-explorer'],
      access: [
        {
          contexts: [ShigoDashboardContext.Main, ShigoDashboardContext.SuperAdmin],
          permissions: [ShigoPermission.ReportingReportBuilderRead],
        },
        {
          contexts: [ShigoDashboardContext.Publisher],
          permissions: [
            ShigoPermission.PublisherDashboardRead,
            ShigoPermission.PublisherDashboardReportingRead,
          ],
        },
      ],
    },
    {
      id: ShigoNavigationItem.PerformanceAnalyzer,
      labelKey: 'nav.reporting.performanceAnalyzer',
      to: '/reporting/performance-analyzer',
      activePaths: ['/reporting/performance-analyzer'],
      access: [
        {
          contexts: [ShigoDashboardContext.Main],
          permissions: [ShigoPermission.ReportingPerformanceRead],
        },
      ],
    },
    {
      id: ShigoNavigationItem.NetworkPerformance,
      labelKey: 'nav.reporting.networkPerformance',
      to: '/reporting/network-performance',
      activePaths: ['/reporting/network-performance'],
      access: [
        {
          contexts: [ShigoDashboardContext.SuperAdmin],
          permissions: [ShigoPermission.ReportingReportBuilderRead],
        },
      ],
    },
    {
      id: ShigoNavigationItem.SavedReports,
      labelKey: 'nav.reporting.savedReports',
      to: '/reporting/saved-reports',
      activePaths: ['/reporting/saved-reports'],
      access: [
        {
          contexts: [ShigoDashboardContext.Main],
          permissions: [ShigoPermission.ReportingSavedReportsRead],
        },
      ],
    },
  ],
};
